export default {
  textureGrid: 'remove-bg-texture-grid',
  textureBtn: 'remove-bg-texture-btn',
  colorBtn: 'remove-bg-color-btn',
  tabs: 'remove-bg-tabs',
};
